import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { Divider } from "@/shared/base/components/Divider/Divider";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  IconButton,
  Theme,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { v4 as uuid } from "uuid";

export function FaqSection() {
  const theme = useTheme();
  const { faqs, languages } = useTeamConfig();
  const styles = useStyles(theme);

  if (faqs.length === 0) return null;

  return (
    <Box>
      <Box>
        <Divider>
          <Box
            bgcolor={theme.palette.background.paper}
            width={"fit-content"}
            pr={4}
          >
            <Typography variant="h6" fontWeight={"700"} color="text.primary">
              FAQ
            </Typography>
          </Box>
        </Divider>
      </Box>
      {languages?.purchaseSeats?.faqDisclaimer ? (
        <Box mt={5}>
          <Typography variant="body1" color="text.secondary">
            {languages.purchaseSeats.faqDisclaimer}
          </Typography>
        </Box>
      ) : null}
      <Box mt={5}>
        <Grid container gap={2}>
          {faqs.map((itm) => {
            return (
              <Grid key={uuid()} item xs={12}>
                <Accordion sx={styles.accordion}>
                  <AccordionSummary
                    expandIcon={
                      <IconButton>
                        <MdOutlineKeyboardArrowDown />
                      </IconButton>
                    }
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Box>
                      <Typography
                        fontSize={"1rem"}
                        fontWeight={600}
                        color="text.primary"
                      >
                        {itm.title}
                      </Typography>
                    </Box>
                  </AccordionSummary>

                  <AccordionDetails sx={styles.accordionDetails}>
                    <Box pt={2}>
                      <Typography variant="body1" color="text.secondary">
                        {itm.description}
                      </Typography>
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Box>
  );
}

function useStyles(theme: Theme) {
  return {
    accordion: {
      borderRadius: "6 !important",
      boxShadow: "none",
      border: `1px solid ${theme.palette.divider}`,
      paddingTop: 1,
      paddingBottom: 1,

      "& .MuiAccordionSummary-root": {
        paddingLeft: 2,
        paddingRight: 2,
      },

      "& .MuiAccordionSummary-expandIconWrapper svg": {
        width: "1.5rem",
        height: "1.5rem",
      },
      "&.MuiAccordion-root.Mui-expanded": {
        margin: "0px !important",
      },
    },
    accordionDetails: {
      borderTop: `1px solid ${theme.palette.divider}`,
    },
  };
}
